import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='non-qualified-retirement-plan-faq' // '-section-container' will be appended dynamically
    className='nmx-no-print'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about non&#45;qualified retirement plans&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-non-qualified-retirement-plan'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'non-qualified-retirement-plan-offering-faq',
              title: <>How can offering a non&#45;qualified retirement plan help employees be <WidowBlock>more tax&#45;efficient&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  When participating in a non&#45;qualified retirement plan, the compensation is deferred, so employees won&#39;t have to claim the income when their income (and tax rate) is probably already high. Instead, your employee can draw on the funds once they retire when they&#39;ll most likely be in a lower tax bracket. Get more details on offering a non&#45;qualified retirement plan.&nbsp;
                  <Link
                    id='non-qualified-retirement-plan-offering-faq-link'
                    variant='primaryDeemphasize'
                    linkUrl='/find-a-financial-advisor/'>
                    Talk to one of our financial advisors
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'non-qualified-retirement-plan-why-offer-faq',
              title: <>Why offer a non&#45;qualified <WidowBlock>retirement plan&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  They&#39;re a smart and efficient way to keep a company&#39;s compensation competitive for executives and other high&#45;earning employees. They can help retain and attract employees because non&#45;qualified retirement plans can be tailored to individuals, they don&#39;t have annual contribution limits like qualified plans, and they&#39;re tax efficient. Talk to one of our financial advisors about how a non&#45;qualified retirement plan can help your company.&nbsp;
                  <Link
                    id='non-qualified-retirement-plan-why-offer-faq-link'
                    variant='primaryDeemphasize'
                    linkUrl='/find-a-financial-advisor/'
                    ariaLabel='Learn why we offer non&#45;qualified retirement plans from a Northwestern Mutual Financial Advisor.'>
                    Get matched today
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'non-qualified-retirement-plan-what-is-best-faq',
              title: <>What type of non&#45;qualified retirement plan is best for <WidowBlock>my company&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  There are many options to choose from, like an Elective Deferred Compensation Plan, Supplemental Executive Retirement Plan, or a Phantom Stock Plan. To know which options are best for you and your key employees, talk to one of our financial advisors.&nbsp;
                  <Link
                    id='non-qualified-retirement-plan-what-is-best-faq-link'
                    variant='primaryDeemphasize'
                    linkUrl='/find-a-financial-advisor/'
                    ariaLabel='Get matched with a Financial Advisor.'>
                    Get matched today
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'non-qualified-retirement-plan-exemption-faq',
              title: <>What does a special disclosure exemption mean in the Employee Retirement Income Security <WidowBlock>Act (ERISA)&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  By participating in or being a sponsor of a non&#45;qualified retirement plan, you are not acting outside the regulations and standards established by the federal government in 1974. Setting up a non&#45;qualified retirement plan for select management or highly compensated employees lets employers, business owners, and employees take advantage of the ERISA exemption to save more money for retirement than they could in a qualified plan. See if a non&#45;qualified retirement plan is right for you.&nbsp;
                  <Link
                    id='non-qualified-retirement-plan-exemption-faq-link'
                    variant='primaryDeemphasize'
                    linkUrl='/find-a-financial-advisor/'
                    ariaLabel='Talk to a Northwestern Mutual Financial Advisor today.'>
                    Talk to one of our financial advisors
                  </Link>.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
